import { BarChart, ResponsiveContainer } from "recharts";
import PropTypes from "prop-types";

import { strCode } from "../../consts";
import { t } from "../../services";
import { useChartData, useHideTooltip } from "../../hooks";

import chartHelpers from "./helpers/chartHelpers";
import ChartLegend from "./components/ChartLegend";
import { WrapperContainer, Paragraph2, FlexContainers, GradientLoader } from "../../components";
import { ChartWrapper } from "./styled";

const DashboardBarChart = ({
  data,
  isLoading,
  isError,
  metricsConfig,
  isErrorMetrics,
  yAxisLabel,
  yAxisUnit,
  isCustomTicks,
  deleteNullMetrics
}) => {
  const { formattedData, filteredMetricsConfig, maxY, dataKeys, opacity, setOpacity } =
    useChartData({ data, isBarChart: true, metricsConfig, deleteNullMetrics });
  const { isTooltipHidden, handleMouseLeave, handleMouseEnter } = useHideTooltip()

  return (
    <ChartWrapper width="100%">
      {isLoading ? (
        <GradientLoader width={"100%"} height={300} />
      ) : isError ? (
        <WrapperContainer Container={FlexContainers.FlexColumnCenter} width="100%" height={300}>
          <Paragraph2>{t(strCode.DASHBOARD_FETCH_ERROR)}</Paragraph2>
        </WrapperContainer>
      ) : data && data?.length > 0 ? (
        <WrapperContainer
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          Container={FlexContainers.FlexColumnCenter}
          gap={8}
          data-testid="bar-chart">
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={formattedData} margin={{ top: 30, right: 10, left: 10, bottom: 16 }}>
              {chartHelpers.getBars({
                metrics: dataKeys,
                metricsConfig: filteredMetricsConfig,
                opacity,
                isErrorMetrics
              })}

              {chartHelpers.getChartAxes({
                data: formattedData,
                maxY: maxY,
                yAxisLabel: yAxisLabel,
                yAxisUnit: yAxisUnit,
                isBarChart: true,
                metricsConfig: filteredMetricsConfig,
                isCustomTicks,
                isTooltipHidden,

              })}
            </BarChart>
          </ResponsiveContainer>
          <ChartLegend
            metricsConfig={filteredMetricsConfig}
            opacity={opacity}
            setOpacity={setOpacity}
          />
        </WrapperContainer>
      ) : (
        <WrapperContainer Container={FlexContainers.FlexColumnCenter} width="100%" height={300}>
          <Paragraph2>{t(strCode.NO_DATA_FOR_CHART)}</Paragraph2>
        </WrapperContainer>
      )}
    </ChartWrapper>
  );
};

DashboardBarChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      metrics: PropTypes.objectOf(PropTypes.number).isRequired
    })
  ).isRequired,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  metricsConfig: PropTypes.shape(PropTypes.object).isRequired,
  isErrorMetrics: PropTypes.bool,
  yAxisLabel: PropTypes.string,
  yAxisUnit: PropTypes.string,
  isCustomTicks: PropTypes.bool,
  deleteNullMetrics: PropTypes.bool
};

export default DashboardBarChart;
